import { InsertItemsAtOffsetAndSetCursorAction, CursorStream } from './types';

/**
 * @param streamState
 * @param action
 */
export const handleInsertItemsAtOffsetAndSetCursorAction = (
  streamState: CursorStream,
  action: InsertItemsAtOffsetAndSetCursorAction
): CursorStream => {
  const newTotal =
    streamState.total !== undefined
      ? streamState.total + action.items.length
      : undefined;
  // Prepend - optimisation concat faster than slice and spread
  if (action.offset === 0) {
    return {
      ...streamState,
      cursor: action.newCursor || streamState.cursor,
      items: action.items.concat(streamState.items || []),
      total: newTotal,
    };
  }
  // Append - optimisation concat faster than slice and spread
  if (action.offset === streamState.items.length || action.offset === -1) {
    return {
      ...streamState,
      cursor: action.newCursor || streamState.cursor,
      items: (streamState.items || []).concat(action.items),
      total: newTotal,
    };
  }
  // Inject
  const current = streamState.items || [];
  const newItems = [
    ...current.slice(0, action.offset),
    ...action.items,
    ...current.slice(action.offset),
  ];
  return {
    ...streamState,
    cursor: action.newCursor || streamState.cursor,
    items: newItems,
    total: newTotal,
  };
};
